// -- Import Actions
import { commonActions } from  '../../actions/commonActions';
import {categorySetItem, categoryAddItem,categoryGetItem} from '../../actions/productActions';
import { connect } from 'react-redux';
import AddEditForm from '../../components/product/categoryAddEditForm';
import {API_FETCH} from '../../services/FetchService';
import {alertConstants,commonConstants} from "../../constants";
import {reset} from "redux-form";


const mapStateToProps = state => {
    return {
        common: state.common,
        initialValues: state.product.categoryGetItem,
        userValue: state.app.currentUser
    }
};


const mapDispatchToProps = dispatch => ({
    onPageLoad: view => {
        dispatch(commonActions.pagePreLoaded(view))
    },
    getItem: (id) => {
        dispatch(getItem(id));
    },

    /* ------------ -------------- ------------*/
    /* ------------ ON SUbmit Form ------------*/
    /* ------------ -------------- ------------*/
    onSubmit: (value)=>{
        if(value.mode == 'edit')
            dispatch(edit(value));
        else
            dispatch(add(value));
    },

});


/* ------------------------------------------------ */
/* -------- Functions of mapDispatchToProps ------- */
/* ------------------------------------------------ */

const add = (values,mode) => {
    return (dispatch, getState) => {
        let formData = {
            'title'        : values.title,
            'description'  : values.description,
            'product_type' : values.product_type
        };
        dispatch({type: commonConstants.FORM_REQUEST});
        API_FETCH.post('/product/category', formData).then(res => {
            dispatch(categoryAddItem(res.data.lists));
            if(res.status === 201) {
                dispatch({type: commonConstants.FORM_SUCCESS});
                dispatch({
                    type: alertConstants.SUCCESS,
                    message: 'عملیات شما با موفقیت انجام شد'
                })
                dispatch(reset('addCategory'));
            }else {
                dispatch({type: commonConstants.FORM_FAILURE});
                dispatch({
                    type: alertConstants.ERROR,
                    message: 'خطا در ایجاد'
                })
            }
        }).catch(error => {
            dispatch({type: commonConstants.FORM_FAILURE});
            dispatch({
                type: alertConstants.ERROR,
                message: 'خطای سرور'
            })
        });

    }
}

const edit = (values) => {
   let id = values._id;

   return (dispatch, getState) => {
        let formData = {
            'title'        : values.title,
            'description'  : values.description,
            'product_type' : values.product_type
        };

        dispatch({type: commonConstants.FORM_REQUEST});
        API_FETCH.put('product/category/'+id, formData).then(editRes => {
            dispatch(categorySetItem(editRes.data));
            if(editRes.status === 200) {
                dispatch({type: commonConstants.FORM_SUCCESS});
                dispatch({
                    type: alertConstants.SUCCESS,
                    message: 'عملیات شما با موفقیت انجام شد'
                })
            }else {
                dispatch({type: commonConstants.FORM_FAILURE});
                dispatch({
                    type: alertConstants.ERROR,
                    message: 'خطا در ویرایش'
                })
            }
        }).catch(error => {
            dispatch({type: commonConstants.FORM_FAILURE});
            dispatch({
                type: alertConstants.ERROR,
                message: 'خطای سرور'
            })
        });

    }
}

const getItem = (id) => {
    return (dispatch, getState) => {
        API_FETCH.get('product/category/'+id).then(categoryInfo => {
            dispatch(categoryGetItem(categoryInfo.data.result));
        }).catch(error => {
            console.log(error);
        });
    }
}


export default connect(mapStateToProps, mapDispatchToProps)(AddEditForm);
